// extracted by mini-css-extract-plugin
export default {"clientList":"Anchors_clientList__LVqw9","wrapper":"Anchors_wrapper__+hh4r","fixedHeader":"Anchors_fixedHeader__w7KgQ"};